<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title data-test="title" #title (click)="onTitleClick()">Campaign Incentive Set</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary">
        Define which incentives you want in this set and then order them.
    </ion-list-header>

    <form name="form" (ngSubmit)="f.form.valid && onSaveClick(f)" #f="ngForm" novalidate>
        <ion-list lines="none">

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Incentive Set Name</ion-label>
                <ion-input color="secondary" type="text" name="incentiveSetName" #incentiveSetName="ngModel" 
                    [ngClass]="{ 'is-invalid': f.submitted && incentiveSetName.invalid }" required
                    [(ngModel)]="incentiveSet.setName" id="incentiveSetName" data-test="incentiveSetName">
                </ion-input>

                <ion-buttons class="itemButtons" slot="end">
                    <ion-button class="itemButton" color="primary" expand="full" fill="solid" 
                            id="search" (click)="openPromptForIncentivesClick()" data-test="search">
                        <ion-icon name="settings-outline"></ion-icon>
                    </ion-button>
                </ion-buttons>
                @if (submitted && incentiveSetName.invalid) {
  <div data-test="incentiveSetErr">
                    <div class="validationErrorMsg">Incentive Set Name is required.</div>
                </div>
}                    
            </ion-item>
        </ion-list>
        
        <ion-list>   
            <ion-reorder-group disabled="false" (ionItemReorder)="onIncentiveMove($event)">
                @for (incentive of selectedIncentives; track $index) {
  <ion-item>
                    <ion-grid>
                        <ion-row class="ion-align-items-center">
                            <ion-col size="11" size-md="10" class="ion-float-left">
                                <span class="line1">{{incentive.title}}</span><br />
                                @if (incentive.line1 || incentive.line2) {
  <div>
                                    <span class="line2">{{incentive.line1}}</span><br />
                                    <span class="line2">{{incentive.line2}}</span><br />
                                </div>
}
                                @if (incentive.note) {
  <div>
                                    <span class="line2">{{incentive.note}}</span><br />
                                </div>
}
                            </ion-col>
                            <ion-col size="1" class="ion-float-right">
                                @if (selectedIncentives.length > 1) {
  <ion-reorder></ion-reorder>
}
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </ion-item>
}
            </ion-reorder-group>    
        </ion-list>
    </form>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button data-test="save" color="primary" expand="full" (click)="onSaveClick(f)">Save</ion-button>
    </ion-toolbar>
</ion-footer>